import * as React from "react";
import PropTypes from "prop-types";
import Button from "@mui/material/Button";
import { styled } from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import Typography from "@mui/material/Typography";
import Stack from "@mui/material/Stack";
import Paper from "@mui/material/Paper";
import Box from "@mui/material/Box";
import Divider from "@mui/material/Divider";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));

function BootstrapDialogTitle(props) {
  const { children, onClose, ...other } = props;

  return (
    <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
}

BootstrapDialogTitle.propTypes = {
  children: PropTypes.node,
  onClose: PropTypes.func.isRequired,
};

export default function CustomizedDialogs(props) {
  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  const Item = styled(Paper)(({ theme }) => ({}));

  return (
    <div>
      <Button
        variant="outlined"
        onClick={handleClickOpen}
        sx={{ color: "#000000", border: "none", ":hover": { border: "none" } }}
      >
        Score Details
      </Button>
      <BootstrapDialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={open}
      >
        <BootstrapDialogTitle
          id="customized-dialog-title"
          sx={{ backgroundColor: "#75FDC6" }}
        >
          Score Details: {props.teamName}
        </BootstrapDialogTitle>
        <DialogContent dividers sx={{ backgroundColor: "#75FDC6" }}>
          <Stack direction="row" justifyContent="space-between" spacing={2}>
            <Box>
              <Typography sx={{ fontWeight: "bold" }}>Round-1</Typography>
            </Box>
            <Box>
              <Typography sx={{ fontWeight: "bold" }}>
                {props.round1 == null ? "-" : props.round1}
              </Typography>
            </Box>
          </Stack>
          <Stack direction="row" justifyContent="space-between" spacing={2}>
            <Box>
              <Typography sx={{ fontWeight: "bold" }}>Round-2</Typography>
            </Box>
            <Box>
              <Typography sx={{ fontWeight: "bold" }}>
                {props.round2 == null ? "-" : props.round2}
              </Typography>
            </Box>
          </Stack>
          <Divider sx={{ marginTop: "0.8rem" }}></Divider>
          <Stack
            direction="row"
            justifyContent="space-between"
            spacing={2}
            sx={{ marginTop: "0.5rem" }}
          >
            <Box>
              <Typography sx={{ fontWeight: "bold" }}>Total</Typography>
            </Box>
            <Box>
              <Typography sx={{ fontWeight: "bold" }}>
                {props.total == null ? "-" : props.total}
              </Typography>
            </Box>
          </Stack>
        </DialogContent>
        <DialogActions sx={{ backgroundColor: "#75FDC6" }}>
          <Button autoFocus onClick={handleClose} sx={{ color: "#000000" }}>
            Close
          </Button>
        </DialogActions>
      </BootstrapDialog>
    </div>
  );
}
